<video class="animacion" muted autoplay *ngIf="!animationFinished">
    <source src='assets/Animacion.webm' type="video/webm"/> 
</video>
<div class="title-container">
    <h1>La Pizarra</h1>
    <div class="spacer"></div>
    <form [formGroup]="pizarraService.pizarra" (submit)="save()">
        <mat-form-field>
          <mat-label>Nombre</mat-label>
          <input matInput placeholder="Introduce un nombre" formControlName="name">
          <button class="save-button" matSuffix mat-button type="submit" aria-label="Save">
            <mat-icon aria-hidden="false" fontIcon="save"></mat-icon>
            </button>
        </mat-form-field>
  </form>
</div>  
<div class="custom-container" *ngIf="loaded"> 
    <div class="columna-grande field-container">
        <div class="field">
            <div #tablero class="tablero"></div>
            <canvas #drawingCanvas></canvas>
        </div>
    </div>
    
    <div class="columna-pequeña">
        <form class="controls" [formGroup]="pizarra">
            <!-- EQUIPOS -->
            <mat-form-field>
                <mat-label>Equipos</mat-label>
                <input #team type="text" placeholder="Select team" matInput formControlName="selectTeam"
                    [matAutocomplete]="teamAuto" (input)="filterTeam(team)" (focus)="filterTeam(team)">
                <mat-autocomplete requireSelection #teamAuto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let value of filteredTeams" [value]="value">{{value.name}}</mat-option>
                </mat-autocomplete>
                <button mat-button matSuffix (click)="addTeam($event)" aria-label="Add team">
                    <mat-icon>add</mat-icon>
                </button>
            </mat-form-field>

            <!-- JUGADORES -->
            <mat-form-field>
                <mat-label>Jugadores</mat-label>
                <input #player type="text" placeholder="Select player" matInput formControlName="selectPlayer"
                        [matAutocomplete]="playerAuto" (input)="filterPlayer(player)" (focus)="filterPlayer(player)" (select)="addPlayer()">
                <mat-autocomplete requireSelection #playerAuto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let value of filteredPlayers" [value]="value">{{value}}</mat-option>
                </mat-autocomplete>
            </mat-form-field>
            
            <!-- ELEMENTOS -->
            <mat-form-field>
                <mat-label>Elementos</mat-label>
                <mat-select formControlName="selectElement">
                    <mat-option value="area">Circulo punteado</mat-option>
                    <mat-option value="zona">Zona</mat-option>
                    <mat-option value="champions">Champions</mat-option>
                    <mat-option value="MarcoCara">MarcoCara</mat-option>
                    <mat-option value="MarcoFeliz">MarcoFeliz</mat-option>
                    <mat-option value="Simeone">Simeone</mat-option>
                </mat-select>
            </mat-form-field>

            <!-- BALONES -->
            <mat-form-field>
                <mat-label>Balones</mat-label>
                <mat-select formControlName="selectBall">
                    <mat-option value="balon">Liga</mat-option>
                    <mat-option value="balonucl">Champions</mat-option>
                </mat-select>
            </mat-form-field>
        </form>

        <div class="controls">
            <button mat-button matTooltip="Flecha" (click)="arrowBtnClick()">
                <mat-icon>east</mat-icon>
            </button>
            <button mat-button matTooltip="Flecha discontinua" (click)="arrowDiscontinuaBtnClick()">
                <mat-icon>more_horiz</mat-icon>
            </button>
            <button mat-button matTooltip="Línea recta" (click)="lineBtnClick()">
                <mat-icon>horizontal_rule</mat-icon>
            </button>
            <button mat-button matTooltip="Círculo" (click)="circleBtnClick()">
                <mat-icon>fiber_manual_record</mat-icon>
            </button>
            <button mat-button matTooltip="Borrar dibujo" (click)="eraseBtnClick()">
                <mat-icon>close</mat-icon>
            </button>
            <button mat-button matTooltip="Borrar todos los dibujos" (click)="eraseAllBtnClick()">
                <mat-icon>delete_sweep</mat-icon>
            </button>
            <button mat-button matTooltip="Color" (click)="openColorPicker()">
                <mat-icon>format_color_fill</mat-icon>
            </button>
            <input matInput type="color" #colorPicker [(ngModel)]="color" style="opacity: 0;">
            <button mat-button [disabled]="drawingMode == 'none'" (click)="drawModeBtnClick()">Modo dibujo</button>
        
            <mat-slider thumbLabel min="0.5" max="4" step="0.5">
                <input matSliderThumb (change)="onScaleChange()" [(value)]="scaleSlider">
            </mat-slider>
            <button mat-button matTooltip="Eliminar todas las fichas" (click)="clearTablero()">
                <mat-icon>delete_forever</mat-icon>
            </button>
        </div>
        <mat-divider></mat-divider>
        <mat-card appearance="outlined">
            <mat-card-content>
            <div class="responsive_table">
                <table mat-table [dataSource]="pizarras" matSort class="mat-elevation-z8">        
                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">
                            PIZARRAS GUARDADAS
                        </th>
                        <td mat-cell *matCellDef="let element" (click)="populate(element)"> {{element.name}} </td>
                    </ng-container>

                    <!-- Delete Column -->
                    <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>   
                    <td mat-cell *matCellDef="let element"> 
                        <button mat-button (click)="remove(element._id)">
                        <mat-icon>delete</mat-icon>
                        </button> 
                    </td>
                    </ng-container>
            
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>